import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

@Component({
  selector: 'mandae-options-form-v2',
  templateUrl: './options-form-v2.component.html',
  styleUrls: ['./options-form-v2.component.scss']
})
export class OptionsFormV2Component implements OnInit {

  private _deliveryTypes = [];
  public get deliveryTypes() {
    return this._deliveryTypes;
  }
  @Input() public set deliveryTypes(value: any[]) {
    this._deliveryTypes = value.slice();
    this._deliveryTypes.sort((a, b) => b.indicadorPreco - a.indicadorPreco);
  }
  @Input() submitted = false;

  @Output() tipoEntrega = new EventEmitter<any>();
  @Output() seguro = new EventEmitter<any>();
  @Output() documentoFiscal = new EventEmitter<any>();
  @Output() produtos = new EventEmitter<any[]>();

  public valorDeclaradoInserido = 0;

  private insuranceValidationRules = [
    Validators.min(18),
    Validators.max(10000),
    Validators.required,
  ];

  public withInsurance = new FormControl(true);
  public declaredValue = new FormControl('', {
    validators: this.insuranceValidationRules,
  });

  public tipoDocumentoFiscal = new FormControl('jaTemDocumento');
  public chaveAcesso = new FormControl('');

  public produtosList = new FormArray([this.criarProduto()]);

  public optionsForm = new FormGroup({
    withInsurance: this.withInsurance,
    declaredValue: this.declaredValue,
    tipoDocumentoFiscal: this.tipoDocumentoFiscal,
    produtos: this.produtosList,
  });

  public selectedDeliveryType;

  constructor() { }

  get produtosArray(): FormGroup[] {
    return this.produtosList.controls as FormGroup[];
  }

  get chaveDigitosCount(): number {
    return (this.chaveAcesso.value || '').length;
  }

  ngOnInit() {
    this.withInsurance.valueChanges.subscribe(() => this.emitirSeguro());

    this.declaredValue.valueChanges.subscribe((value: number) => {
      this.valorDeclaradoInserido = value;
      this.emitirSeguro();
    });

    // Emite o estado inicial (seguro marcado e valor vazio) para o controller não depender de uma edição
    this.emitirSeguro();

    this.tipoDocumentoFiscal.valueChanges.subscribe(() => this.emitirDocumentoFiscal());
    this.chaveAcesso.valueChanges.subscribe(() => this.emitirDocumentoFiscal());
    this.produtosList.valueChanges.subscribe(values => this.produtos.emit(values));
  }

  setDeliveryType(type: any) {
    this.selectedDeliveryType = type;
    this.tipoEntrega.emit(type);
  }

  getDeliveryTypeClass(type: any) {
    return {
      'active': this.selectedDeliveryType && this.selectedDeliveryType.tipo === type.tipo,
      'service-disable': !type.disponivel
    };
  }

  getDeliveryTypeIconClass(deliveryType: any) {
    return {
      'icon-checked': this.selectedDeliveryType && this.selectedDeliveryType.tipo === deliveryType.tipo && deliveryType.disponivel,
      'icon-unchecked': (!this.selectedDeliveryType || this.selectedDeliveryType.tipo !== deliveryType.tipo) && deliveryType.disponivel,
      'icon-disable': !deliveryType.disponivel,
    };
  }

  createDollars(price: number) {
    price = +price;

    if (price > 0) {
      return '<font color="#BBBBBB">' + '$'.repeat(price) + '</font>';
    }

    return '';
  }

  get chaveFormatada(): string {
    const grupos = (this.chaveAcesso.value || '').match(/.{1,4}/g);
    return grupos ? grupos.join(' ') : '';
  }

  formatarChave(event: Event) {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '').slice(0, 44);
    this.chaveAcesso.setValue(digits, { emitEvent: true });
    input.value = this.chaveFormatada;
  }

  criarProduto(): FormGroup {
    return new FormGroup({
      descricao: new FormControl(''),
      quantidade: new FormControl(0),
      valor: new FormControl(0),
    });
  }

  adicionarProduto() {
    this.produtosList.push(this.criarProduto());
  }

  removerProduto(index: number) {
    this.produtosList.removeAt(index);
  }

  private emitirSeguro() {
    const comSeguro = !!this.withInsurance.value;
    this.declaredValue.setValidators(comSeguro ? this.insuranceValidationRules : []);
    this.declaredValue.updateValueAndValidity({ emitEvent: false });

    const valido = !comSeguro || this.declaredValue.valid;
    this.seguro.emit({
      comSeguro,
      valor: comSeguro && valido ? this.declaredValue.value : null,
      valido,
    });
  }

  private emitirDocumentoFiscal() {
    const tipo = this.tipoDocumentoFiscal.value;
    this.documentoFiscal.emit({
      tipo,
      chave: tipo === 'jaTemDocumento' ? this.chaveAcesso.value : null,
    });
  }

}
